import React, {PropTypes} from 'react';

const PageImage = ({imgSource}) => {

  const style = {
      backgroundImage: 'url("'+imgSource+'")'
  };

  return (
    <div className="page-banner-img-container" style={style}>
    </div>
  );
};

PageImage.propTypes = {
  imgSource: PropTypes.string.isRequired
};

export default PageImage;



/** WEBPACK FOOTER **
 ** ./src/components/common/PageImage.js
 **/